module.exports = __webpack_public_path__ + "static/media/wall-street-journal-logo.9351d992.svg";